import Service = require("VSS/Service");
import Utils_Array = require("VSS/Utils/Array");
import Tfs_Admin_Controls_TeamSettings = require("Agile/Scripts/Admin/TeamSettings");

import { TabControlsRegistrationConstants } from "Agile/Scripts/Common/Agile";
import AgileControlsResources = require("Agile/Scripts/Resources/TFS.Resources.AgileControls");
import Configurations = require("Presentation/Scripts/TFS/TFS.Configurations");
import BoardsSettingsControls = require("Agile/Scripts/Board/BoardsSettingsControls");

import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import TFS_TeamAwarenessService = require("Presentation/Scripts/TFS/FeatureRef/TFS.TeamAwarenessService");
import TFS_OM_Common = require("Presentation/Scripts/TFS/TFS.OM.Common");
import TeamServices = require("TfsCommon/Scripts/Team/Services");
import { BacklogConfigurationService } from "Presentation/Scripts/TFS/FeatureRef/BacklogConfiguration/Service";

import Tfs_Work_WebApi = require("TFS/Work/RestClient");

export function registerGeneralSettings(
  teamId: string,
  currentUserTeamPermissions: TeamServices.ITeamPermissions,
  showBacklogVisibilitiesTab: boolean,
  bugSettingData?: Tfs_Admin_Controls_TeamSettings.IBugSettingData
) {
  // register group
  Configurations.TabControlsRegistration.registerTabGroup({
    tabControlId:
      TabControlsRegistrationConstants
        .COMMON_CONFIG_SETTING_INSTANCE_ID,
    id: TabControlsRegistrationConstants.GENERAL_GROUP_ID,
    title: TabControlsRegistrationConstants.GENERAL_GROUP_TITLE,
    order: 30
  });

  // register tabs
  const teamAwareness = TFS_OM_Common.ProjectCollection.getDefaultConnection().getService(
    TFS_TeamAwarenessService.TeamAwarenessService
  );
  const teamSettings = teamAwareness.getTeamSettings(teamId);

  var contextData = TFS_Host_TfsContext.TfsContext.getDefault();
  var httpClient = new Service.VssConnection(
    contextData.contextData
  ).getHttpClient<Tfs_Work_WebApi.WorkHttpClient>(
    Tfs_Work_WebApi.WorkHttpClient
  );
  var backlogConfiguration = BacklogConfigurationService.getBacklogConfiguration();

  if (showBacklogVisibilitiesTab) {
    // Register BugVisibilitiesSettings Tab
    var bugVisibilitiesTabOptions: BoardsSettingsControls.ITeamSettingTabOptions = {
      workHttpClient: httpClient,
      teamSettings,
      backlogConfiguration: backlogConfiguration,
      editable: currentUserTeamPermissions.currentUserHasTeamAdminPermission,
      currentUserTeamPermissions: currentUserTeamPermissions,
      controlType:
        Tfs_Admin_Controls_TeamSettings.BacklogVisibilitiesTeamSettingControl,
      displayNoPermissionsMessage: true,
      bugSettingData
    };

    var generalSettingsRegistrationOptions: Configurations.ITabRegistration<
      any
      > = {
      groupId: TabControlsRegistrationConstants.GENERAL_GROUP_ID,
      id: TabControlsRegistrationConstants.BACKLOGS_TAB_ID,
      title: AgileControlsResources.BacklogVisibilities_Tab_Title,
      tabContent: BoardsSettingsControls.TeamSettingTabContent,
      tabContentOptions: bugVisibilitiesTabOptions,
      order: 10
    };

    Configurations.TabControlsRegistration.registerTab(
      generalSettingsRegistrationOptions
    );
  }

  // Register bugBehavior, weekdays ONLY if requirement level is visible
  if (
    !Utils_Array.contains(
      BacklogConfigurationService.getBacklogConfiguration().hiddenBacklogs,
      BacklogConfigurationService.getBacklogConfiguration().requirementBacklog
        .id
    )
  ) {
    // Register WorkingDaysSettings Tab
    var workingDaysTabOptions: BoardsSettingsControls.ITeamSettingTabOptions = {
      workHttpClient: httpClient,
      teamSettings,
      backlogConfiguration: backlogConfiguration,
      editable: currentUserTeamPermissions.currentUserHasTeamAdminPermission,
      currentUserTeamPermissions: currentUserTeamPermissions,
      controlType:
        Tfs_Admin_Controls_TeamSettings.WorkingDaysTeamSettingControl,
      displayNoPermissionsMessage: true
    };

    var generalSettingsRegistrationOptions: Configurations.ITabRegistration<
      any
      > = {
      groupId: TabControlsRegistrationConstants.GENERAL_GROUP_ID,
      id: TabControlsRegistrationConstants.WORKINGDAYS_TAB_ID,
      title: AgileControlsResources.WorkingDays_Tab_Title,
      tabContent: BoardsSettingsControls.TeamSettingTabContent,
      tabContentOptions: workingDaysTabOptions,
      order: 20
    };

    Configurations.TabControlsRegistration.registerTab(
      generalSettingsRegistrationOptions
    );

    // Register BugBehaviorSettings Tab if bugBehavior is specified in the process
    if (backlogConfiguration.isBugsBehaviorConfigValid) {
      var bugsBehaviorTabOptions: BoardsSettingsControls.ITeamSettingTabOptions = {
        workHttpClient: httpClient,
        teamSettings,
        backlogConfiguration: backlogConfiguration,
        editable:
          currentUserTeamPermissions.currentUserHasTeamAdminPermission,
        currentUserTeamPermissions: currentUserTeamPermissions,
        controlType:
          Tfs_Admin_Controls_TeamSettings.BugsBehaviorTeamSettingControl,
        displayNoPermissionsMessage: true,
        bugSettingData
      };

      generalSettingsRegistrationOptions = {
        groupId: TabControlsRegistrationConstants.GENERAL_GROUP_ID,
        id: TabControlsRegistrationConstants.BUGBEHAVIOR_TAB_ID,
        title: AgileControlsResources.BugBehavior_Tab_Title,
        tabContent: BoardsSettingsControls.TeamSettingTabContent,
        tabContentOptions: bugsBehaviorTabOptions,
        order: 30
      };

      Configurations.TabControlsRegistration.registerTab(
        generalSettingsRegistrationOptions
      );
    }
  }
}
